<template>
    <div class="d-flex flex-column w-100 align-items-center gap-3">
        <h5 class="text-primary text-bold m-0 fs-5 text-center text-uppercase">{{ title }}</h5>
        <div class="w-75 d-flex flex-column gap-3 p-0 position-relative">
            <div class="w-100 d-flex gap-3 align-items-center bg-white border-dashed rounded-1rem px-4 py-3" v-for="answer_key in files">
                <i class="ito-icon" :class="`ito-icon-material-${answer_key.extension}`"></i>
                <div class="d-flex flex-fill flex-column justify-content-center overflow-hidden">
                    <p class="material-name text-truncate" :title="answer_key.name">{{ answer_key.name }}</p>
                    <p class="material-value">{{ formatBytes(answer_key.size) }}</p>
                </div>
                <button class="ito-btn ito-btn-primary" @click="downloadFile(answer_key.url)">{{ $t('download') }} <i class="ito-icon ito-icon-download"></i></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'FileList',
    props: ['title', 'files'],
    methods: {
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },
        downloadFile(url) {
            var filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function () {
                var a = document.createElement('a');
                a.href = window.URL.createObjectURL(xhr.response);
                a.download = filename;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            };
            xhr.open('GET', url);
            xhr.send();
        },
    }
}
</script>
<style scoped>
.border-dashed {
    border: 1px dashed #CCD2E3;
}

.rounded-1rem {
    border-radius: 1rem;
}

.material-name {
    font-size: 10px;
    font-weight: 700;
    color: #0D0D0C;
}

.material-value {
    font-size: 10px;
    font-weight: 400;
    color: #0D0D0C;
}
</style>